import { createI18n } from 'vue-i18n';

// 导入语言文件
import en from '../locales/en.json';
import zh from '../locales/zh.json';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs' // 确保路径正确

const i18n = createI18n({
  legacy: true, // 设为true或者不设置
  allowComposition: true,
  locale: localStorage.getItem('locale') || 'zh', // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages: {
    en,
    zh
  }
});

export default i18n;